<template>
  <div :id="allign">
    <div class="advertise-container">
      <div class="marquee">
        <div class="marquee--inner">
          <span>
            <div v-for="(n, index) in nTimes" :key="index">
              <div
                class="orb"
                v-for="(jobAdvert, index) in activeJobAdvertisement"
                :key="'ads' + index"
              >
                <a :href="jobAdvert.link | getLink" target="_blank"
                  ><img alt="" :src="generateLocalFileUrl(jobAdvert.image_path)"
                /></a>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import { Role, getScope, generateLocalFileUrl } from "@/helpers/helper";

export default {
  name: "Advertise",
  components: {},
  props: ["allign"],
  data() {
    return {
      currentUserRole: getScope(),
      Roles: Object.values(Role),
      generateLocalFileUrl,
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["jobAdvertisements"]),
    nTimes() {
      return !Math.floor(this.activeJobAdvertisement.length / 7)
        ? 7 - Math.floor(this.activeJobAdvertisement.length)
        : 1;
    },
    activeJobAdvertisement() {
      return this.jobAdvertisements.filter(({ is_active }) => is_active) || [];
    },
  },
  methods: {
    ...mapActions(["fetchJobAdvertisement"]),
  },
  mounted() {
    const {
      params: { cus_id, org_id },
    } = this.$route;
    let payload = {
      customer_id: cus_id || null,
    };
    if (org_id) payload.organisation_id = org_id;
    this.fetchJobAdvertisement(payload);
  },
  filters: {
    getLink(link) {
      if (link)
        return /^(?:f|ht)tps?\:\/\//.test(link) ? link : `http://${link}`;
      return "javascript:void(0)";
    },
  },
};
</script>
<style lang="scss" scoped>
#horizontal {
  .marquee--inner {
    display: block;
    width: 500%;
    margin: 0px 0;
    position: absolute;
    animation: hmarquee 20s linear infinite;
  }

  .advertise-container {
    height: 123px;

    .orb {
      display: inline-block;
      float: left;
      transition: all 0.2s ease-out;

      img {
        margin-right: 5px;
        height: 109px;
        width: auto;
      }
    }
  }
}

#verticle {
  .marquee--inner {
    display: block;
    height: 200%;
    width: 100%;
    margin: 0px 0;
    position: absolute;
    animation: vmarquee 20s linear infinite;
  }

  .advertise-container {
    height: calc(100vh - 50px);
  }

  .orb {
    display: inline-block;
    float: left;
    transition: all 0.2s ease-out;

    img {
      border-bottom: dotted 2px $border-primary-color;
      width: 100%;
      margin-bottom: 5px;
    }
  }
}
.advertise-container {
  background: $white;
  padding: 5px;
  box-shadow: -1px 0px 7px 0px $border-primary-color;

  .orb:hover {
    transform: scale(1.2);
    cursor: pointer;
  }

  .marquee {
    height: 100%;
    width: 100%;
    border: 2px solid #eee;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    white-space: nowrap;
  }

  .marquee--inner:hover {
    animation-play-state: paused;
  }
}

@keyframes hmarquee {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}

@keyframes vmarquee {
  0% {
    top: 0%;
  }
  100% {
    top: -100%;
  }
}
</style>
